<template>
  <div>
    <table class="table" v-if="contactPeople.length">
      <thead>
        <tr>
          <th>Nachname</th>
          <th>Vorname</th>
          <th>E-Mail Adresse</th>
          <th>Telefonnummer</th>
          <th>Faxnummer</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="contactPerson in contactPeople" :key="contactPerson.id">
          <td v-text="contactPerson.last_name"></td>
          <td v-text="contactPerson.first_name"></td>
          <td>
            <a :href="`mailto:${contactPerson.email}`" v-text="contactPerson.email"></a>
          </td>
          <td v-text="contactPerson.tel"></td>
          <td v-text="contactPerson.fax"></td>
          <td class="text-right">
            <div class="td-actions">
              <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                 @click="$router.push(`/suppliers/${contactPerson.supplier_id}/contact_people/${contactPerson.id}/edit`)">
                <i class="fa fa-edit"></i>
              </a>
              <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                 @click="deleteContactPerson(contactPerson)">
                <i class="fa fa-close"></i>
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else>Keine Ansprechpartner vorhanden</p>
  </div>
</template>

<script>
export default {
  props: ['contactPeople'],
  methods: {
    async deleteContactPerson (contactPerson) {
      if (confirm(`Ansprechpartner ${contactPerson.last_name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/suppliers/${contactPerson.supplier_id}/contact_people/${contactPerson.id}`).then(({ data }) => {
          const index = this.contactPeople.findIndex(({ id }) => data.id === id)
          this.contactPeople.splice(index, 1)
        })
      }
    }
  }
}
</script>

<style>
</style>
